import * as PowerBI from 'powerbi-client';
import * as PowerBIExtensions from './powerbi-extensions';
import { DashboardPlugin } from './dashboard-plugin.interface';
import { BackendApiService } from '../backendApi.service';

export class AcquisitionDataPlugin implements DashboardPlugin {
  constructor(private backendApiService: BackendApiService,
              private setContainers: (containers: string[]) => void) {
  }

  private hideReport() {
    let report = document.getElementById('dashboard-report');
    report.style.height = '50px';
    report.style.overflow = 'hidden';
    (report.children[0] as HTMLElement).style.height = '1000px';
  }

  private showReport() {
    let report = document.getElementById('dashboard-report');
    report.style.height = null;
    (report.children[0] as HTMLElement).style.height = '100%';
  }

  register(report: PowerBI.Embed): void {
    report.on('pageChanged', async event => {
      this.setContainers([]);
      this.showReport();
    });

    report.on('buttonClicked', async x => {
      if ((x.detail as any).title !== 'Acq Off') {
        this.setContainers([]);
        this.showReport();
        return;
      }

      this.hideReport();
      const containers = await PowerBIExtensions.getSelectedContainers(report, 'intervention');
      this.setContainers(containers);
    });

    this.pingBackendService();
  }

  private pingBackendService() {
    this.backendApiService.getText('/api/GetAppStatus').subscribe(text => {
      setTimeout(this.pingBackendService.bind(this), 60 * 1000);
    });
  }
}
